import "../styles/styles.scss";

import stickyHeaderScroll  from "../js/functions/topHeader";
import scrollSections from '../js/functions/sectionsScroll';
import scollToTopClick from '../js/functions/scollToTopClick';
import handleScrollSection from '../js/functions/callToActionFunctions';
import pageIntro from '../js/functions/page-intro';

document.addEventListener(
     "DOMContentLoaded",
     function() {
      stickyHeaderScroll();
      scrollSections();
      scollToTopClick();
      handleScrollSection();
      pageIntro();
    },
     false
   );